/**
 * Reservation Management Module Constants
 */

// --- Task Management Dashboard ---
export const TASK_MANAGEMENT_URL = '/api/TaskManagement';
export const TASK_MANAGEMENT_STATS_URL = '/api/TaskManagement/Stats';

// --- Reservation List & Detail ---
export const RESERVATION_LIST_URL = '/api/TaskManagement/ReservationList';
export const RESERVATION_DETAIL_URL = '/api/TaskManagement/Reservation';

// --- Early Check-in ---
export const EARLY_CHECKIN_VALIDATE_URL = '/api/TaskManagement/EarlyCheckin/Validate';
export const EARLY_CHECKIN_APPLY_URL = '/api/TaskManagement/EarlyCheckin/Apply';

// --- Late Checkout ---
export const LATE_CHECKOUT_VALIDATE_URL = '/api/TaskManagement/LateCheckout/Validate';
export const LATE_CHECKOUT_APPLY_URL = '/api/TaskManagement/LateCheckout/Apply';

// --- Extend Stay ---
export const EXTEND_STAY_VALIDATE_URL = '/api/TaskManagement/ExtendStay/Validate';
export const EXTEND_STAY_APPLY_URL = '/api/TaskManagement/ExtendStay/Apply';

// --- Confirm Checkout ---
export const CONFIRM_CHECKOUT_URL = '/api/TaskManagement/ConfirmCheckout';

// --- Extension / Move ---
export const AVAILABLE_PROPERTIES_URL = '/api/TaskManagement/Extension/AvailableProperties';
export const MOVE_TO_PROPERTY_URL = '/api/TaskManagement/Extension/MoveToProperty';
